import API from '../apiCreate'
import type {
  CheckIsActiveResponse,
  StartActivationRequest,
  StartActivationResponse,
  ActivateRequest,
  ActivateResponse,
  DetachRequest,
  DetachResponse,
} from './integrationRecipient.types'

export const integrationRecipientApi = {
  checkIsActive: (integrationId: number, userId: number) =>
    API.get<CheckIsActiveResponse>(
      `integration-recipient/check-is-active/${integrationId}?user_id=${userId}`,
    ),

  startActivation: (integrationId: number, data: StartActivationRequest) =>
    API.post<StartActivationResponse>(
      `integration-recipient/start-activation/${integrationId}`,
      data,
    ),

  activate: (integrationId: number, data: ActivateRequest) =>
    API.post<ActivateResponse>(
      `integration-recipient/activate/${integrationId}`,
      data,
    ),

  detachUser: (integrationId: number, data: DetachRequest) =>
    API.post<DetachResponse>(
      `integration-recipient/detach-user/${integrationId}`,
      data,
    ),
}
